import React, { useState, useRef } from "react";
import { Dialog } from "primereact/dialog";
import ExportOverlay from "../ExportFile/overlaypanel";
import { useReactToPrint } from "react-to-print";
import { DataTable } from "primereact/datatable";

export default function ChartWrapper(props) {
  const {
    dialogWidth,
    dialogHeight,
    dialogHeaderStyle,
    dialogStyle,
    infoTooltipComponent: InfoTooltip,
    infoTooltipTitle = "Default Title",
    infoTooltipDescription = "Default description.",

    isMaximizedwrap,
    onMaximizewrap,
    onMinimizewrap,
    // ...other props
  } = props;
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isMaximized, setIsMaximized] = useState(false);
  const [isFontBig, setIsFontBig] = useState(false);
  const [showInfoTooltip, setShowInfoTooltip] = useState(false);
  const [showInfoTooltipCard, setShowInfoTooltipCard] = useState(false);
  const Bots = useRef();

  const handleMaximizeToggle = () => {
    if (isMaximizedwrap) {
      onMinimizewrap();
    } else {
      onMaximizewrap();
    }
  };

  // const InfoTooltip = ({ title, description }) => (
  //   <div className="absolute top-full right-[-1rem] mt-1 flex flex-col items-center z-50">
  //     <div className="bg-[#424242] w-[350px] text-white text-sm rounded-lg px-5 py-3 shadow-lg max-w-[400px] text-center">
  //       <div className="font-semibold mb-1 text-start">{title}</div>
  //       <div className="text-xs  text-start mt-2">{description}</div>
  //     </div>
  //     <div className="w-2 h-2 bg-[#424242] rotate-45 -mt-[105px] ml-[18.5rem]"></div>
  //   </div>
  // );

  const openPopup = () => {
    setIsPopupOpen(true);
    setIsFontBig(true);
  };

  const [isPrinting, setisPrinting] = useState(false);
  const handlePrint = useReactToPrint({
    content: () => Bots.current,
    documentTitle: props.header || "Print Chart",
    removeAfterPrint: true,
    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        document.body.classList.add("print-blur");
        // Wait for React to finish rendering
        requestAnimationFrame(() => {
          setTimeout(() => {
            // 🔄 Resize chart before print
            if (Bots.current?.getEchartsInstance) {
              Bots.current.getEchartsInstance().resize();
            }

            resolve();
          }, 1000); // Delay to let DOM settle
          setisPrinting(true);
        });
      });
    },
    onAfterPrint: () => {
      document.body.classList.remove("print-blur");
      setisPrinting(false)
    },
    pageStyle: `
   @page {
      size: ${props.isTable ? "A3 landscape" : "A4 landscape"};
      margin: 10mm;
    }

    body {
      background: ${props.isTable ? "" : "url('/images/Payroll_bg.jpg') no-repeat center top"};
      background-size: cover;
      font-family: Arial, sans-serif;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
      margin: 0;
      padding: 10mm;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .print-header {
      text-align: center;
      font-size: 14px;
      font-weight: bold;
      margin: 20px 0;
    }

    div {
      width: 100% !important;
      max-width: 100% !important;
    }

    table {
      width: 100% !important;
      max-width: 100% !important;
      table-layout: fixed;
    }

    ${props.isTable ? `
      .print-content {
      display: block !important;
      width: 100% !important;
      padding: 10mm;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
      ` : `
      .print-content {
      width: 110rem !important;
      padding: 10mm;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    `}

    .print-content table * {
      font-weight: 300 !important;
      font-size: 14px !important;
    }

    #chart-container {
      background-color: white !important;
      width: 100rem !important;
      height: 350px !important;
      display: flex;
      border-radius: 10px;
      padding: 20px;
      box-sizing: border-box;
      transform: scale(1.05); /* Slight zoom */
      page-break-inside: avoid;
    }
  `
  });

  return (
    <div>
      {/* isMaximized ? "fixed inset-0 bg-white z-[9999] overflow-auto p-4" : "" */}
      <div className="p-2 rounded-lg pl-0 ">
       {/* <div className={isMaximizedwrap ? "fixed inset-0 bg-white z-[9999] overflow-auto p-4" : ""}> */}
        <div className="flex items-center justify-between mt-[-1.9rem]">
          <div>
            <h3 className="text-[15px] text-[#7C2F3E] font-semibold">
              {props.title}
            </h3>
            <p className="text-sm text-gray-600">{props.subtitle}</p>
          </div>

          <div className="flex items-center gap-2">
            {props.infoIcon && (
              <div className="relative group">
                <button onClick={() => setShowInfoTooltip((prev) => !prev)}>
                  <img src="/images/infoIcon.png" width="20" alt="Info" />
                </button>
                {showInfoTooltip && (
                  <InfoTooltip
                    title={infoTooltipTitle}
                    description={infoTooltipDescription}
                  />
                )}
                <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:flex flex-col items-center z-20">
                  <div className="bg-[#424242] text-white text-[14px] rounded px-2 py-1 shadow-lg">
                    Info
                  </div>
                  <div className="w-2 h-2 bg-[#424242] rotate-45 mt-[-4px]"></div>
                </div>
              </div>
            )}
            {props.MaxiIcon && (
              <div className="relative group">
                {/* <button onClick={handleMaximizeToggle}>
                  <img
                    src="/images/MaximizeIcon.png"
                    width="20"
                    alt="Maximize Icon"
                  />
                </button> */}
                <button onClick={handleMaximizeToggle}>
                <img
                  src={
                    !isMaximizedwrap
                      ? "/images/MaximizeIcon.png"
                      : "/images/minimize.png"
                  }
                  width="20"
                  alt={isMaximizedwrap ? "Minimize" : "Maximize"}
                />
          </button>
                <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:flex flex-col items-center z-20">
                  <div className="bg-[#424242] text-white text-[14px] rounded px-2 py-1 shadow-lg">
                    {isMaximizedwrap ? "Minimize" : "Maximize" }
                  </div>
                  <div className="w-2 h-2 bg-[#424242] rotate-45 mt-[-4px]"></div>
                </div>
              </div>
            )}
            {props.ExportIcon && (
              <div className="relative group">
                {/* <button>
                  <img
                    src="/images/exportIcon.png"
                    width="20"
                    alt="Export Icon"
                  />
                </button> */}
                <ExportOverlay ui data={props.apidata} fileName={props.infoTooltipTitle} columns={props.exportColumns} />
                <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:flex flex-col items-center z-20">
                  <div className="bg-[#424242] text-white text-[14px] rounded px-2 py-1 shadow-lg">
                    Export
                  </div>
                  <div className="w-2 h-2 bg-[#424242] rotate-45 mt-[-4px]"></div>
                </div>
              </div>
            )}
            {props.PrintIcon && (
              <div className="relative group">
                <button onClick={handlePrint} disabled={isPrinting}>
                  {isPrinting ?
                    <i className="pi pi-spin pi-spinner t" />
                    : <img
                      src="/images/printIcon.png"
                      width="20"
                      alt="Print Icon"
                    />}
                </button>
                <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:flex flex-col items-center z-20">
                  <div className="bg-[#424242] text-white text-[14px] rounded px-2 py-1 shadow-lg">
                    Print
                  </div>
                  <div className="w-2 h-2 bg-[#424242] rotate-45 mt-[-4px]"></div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div ref={Bots} className="print-content"
          style={{
            width: isPrinting ? "65vw" : "100%",
            height: isPrinting ? dialogHeight : "100%",
            padding: isPrinting ? "20px" : "0px",
          }}
        >
          {props.data && React.cloneElement(props.data, { isMaximized: true })}
        </div>
        {isPrinting && props.isTable && <div style={{
          display: 'none',
        }} className="print-content" ref={Bots}>
          {lookForDataTable(props.data)}
        </div>}
      </div>
    </div>
  );
}



function lookForDataTable(element, isPrintMode = true) {
  if (!React.isValidElement(element)) return element;

  // If this is the DataTable, clone it with modified props
  if (element.type === DataTable) {
    return React.cloneElement(element, {
      paginator: !isPrintMode,
      scrollable: !isPrintMode,
      // scrollHeight: isPrintMode ? '400px' : null,
      scrollHeight: null,
      // className: isPrintMode ? 'print-mode' : 'normal-mode'
    });
  }

  // Recursively clone children
  const clonedChildren = React.Children.map(element.props.children, (child) =>
    lookForDataTable(child, isPrintMode)
  );

  // Clone the current element with cloned children
  return React.cloneElement(element, { ...element.props }, clonedChildren);
}